
import {finalize} from 'rxjs/operators';
import { assign } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { DLRootCertificate } from './root-certificate';
import { DLRootCertificateService, DLRootCertificateFilter } from './root-certificate.service';
import { DLRootCertificateFilterDialogComponent } from './root-certificate-filter-dialog.component';
import { NotifierService, DialogService } from '../../ui';

const FILTER_KEY = 'dl-root-certificates.filter';

@Component({
  templateUrl: './root-certificate-list.component.html',
})
export class DLRootCertificateListComponent implements OnInit {

  filter: DLRootCertificateFilter;

  perPage = 10
  rootCertificatesCount: number = 0
  rootCertificates: DLRootCertificate[]

  constructor(
    private rootCertificateService: DLRootCertificateService,
    private router: Router,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.filter = new DLRootCertificateFilter();

    // Load filter from localStorage
    if(window.localStorage) {
      try {
        let data = window.localStorage.getItem(FILTER_KEY);

        let filterData = JSON.parse(data);

        assign(this.filter, filterData);
      }
      catch(err) {
      }
    }
    
    this.fetch();
  }

  fetchMore() {
    this.fetch(this.rootCertificates.length);
  }

  private fetch(offset = 0, limit = this.perPage, replace = false) {
    this.notifier.startProgress();

    this.filter.offset = offset;
    this.filter.limit = limit;

    this.rootCertificateService
      .rootCertificates(this.filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Replace
        if (replace) {
          this.rootCertificates = result.rootCertificates;
        }
        // Append
        else {
          this.rootCertificates = [...this.rootCertificates || [], ...result.rootCertificates];
        }

        this.rootCertificatesCount = result.rootCertificatesCount;
      });
    
    // Save filter to localStorage
    if(window.localStorage) {
      window.localStorage.setItem(FILTER_KEY, JSON.stringify(this.filter));
    }
  }

  showDLRootCertificate(rootCertificate: DLRootCertificate, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      this.router.navigate(['documents-ledger', 'root-certificates', rootCertificate.id]);
    }
  }

  applyFilter() {
    this.dialogService.show({
      component: DLRootCertificateFilterDialogComponent,
      props: {

        filter: this.filter,

        onClose: () => {
          this.dialogService.hide();
        },

        onApply: (filter: DLRootCertificateFilter) => {
          this.fetch(0, this.perPage, true);
        }
      }
    });
  }

  clearSearch() {
    this.filter.search = '';

    this.fetch(0, this.perPage, true);
  }

  delete(rootCertificate: DLRootCertificate) {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer ce certificat racine?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.rootCertificateService
          .delete(rootCertificate.id)
          .subscribe((id) => {
            this.notifier.success('Certificat racine supprimé avec succès');

            this.fetch(0, this.rootCertificates.length, true);
          }, (err) => {
            this.notifier.endProgress();
          });
      });
    
    return false;
  }
}
